import { http } from './config'

const auth = {
    headers: {Authorization: 'Bearer ' + localStorage.getItem('token')} 
}

export default {
    config:() => {
        return http.get('config', auth)
    },
    prazoMedio:() => {
        return http.get('prazomedio', auth)
    },
    rota:() => {
        return http.get('rota', auth)
    },
    Prota:(data) => {
        return http.post('rota', data, auth)
    },
    comissao:() => {
        return http.get('comissao', auth)
    },
    especial:() => {
        return http.get('especial', auth)
    },
    campanha:() => {
        return http.get('campanha', auth)
    },
    extra:() => {
        return http.get('extra', auth)
    },
    orcamento:(data) => {
        return http.post('orcamento', data, auth)
    },
    getOrcamento:(data) => {
        return http.post('getorcamento', data, auth)
    },
    getAllOrcamento:() => {
        return http.get('allorcamentos', auth)
    },
    getOrcamentoRepres:(data) => {
        return http.post('represorcamentos', data, auth)
    },
    itOrcamento:(data) => {
        return http.post('itorcamento', data, auth)
    },
    UniqOrcamento:(data) => {
        return http.post('orcamentoUniq', data, auth)
    },
    ItemUniqOrcamento:(data) => {
        return http.post('itemorcamentoUniq', data, auth)
    },
    upOrcamento:(data)=> {
       return http.post('uporcamento', data, auth)  
    },
    upItOrcamento:(data)=> {
        return http.post('upitorcamento', data, auth)  
     },
	 delItOrcamento:(data)=> {
        return http.post('delitorcamento', data, auth)  
     },
     confOrcamento:(data)=> {
        return http.post('confOrcamento', data, auth)  
     },
     insPrazoMedio:(data)=> {
         return http.post('insPrazoMedio', data, auth)
     },
     altPrazoMedio:(data)=> {
        return http.post('altPrazoMedio', data, auth)
    },
    insRota:(data)=> {
        return http.post('insRota', data, auth)
    },
    altRota:(data)=> {
       return http.post('altRota', data, auth)
   },
    aprovOrc:(data)=> {
        return http.post('aprovOrcamento', data, auth)
    },
    getRegional:(data)=> {
        return http.post('getRegional', data, auth)
    }
}


